import { render, staticRenderFns } from "./IsList.vue?vue&type=template&id=3072bec4&scoped=true"
import script from "./IsList.vue?vue&type=script&lang=ts"
export * from "./IsList.vue?vue&type=script&lang=ts"
import style0 from "./IsList.vue?vue&type=style&index=0&id=3072bec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072bec4",
  null
  
)

export default component.exports